<template>
  <v-container class="mt-16 animate__animated animate__fadeIn">
    <!-- Desktop View -->
    <v-row
      class="mb-10"
      v-if="device.desktop"
    >
      <v-col cols="4">
        <img
          :src="thumbnail"
          alt=""
          srcset=""
          width="100%"
          height="350px"
        >
        <v-row>
          <v-col
            cols="3"
            v-for="(item,index) in record.images"
            :key="index"
          >
            <img
              :src="item.path"
              alt=""
              srcset=""
              width="100%"
              @mouseenter="setThumbnail(item.path)"
            >
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="5">
        <div class="ant-font-viga ant-title">
          {{ record.name }}
        </div>
        <div class="ant-font-viga-xs mt-2">
          Dilihat : 100+ <v-icon color="orange darken-1">mdi-medal</v-icon> 100+
        </div>
        <div class="ant-lg-title font-weight-bold mt-5 mb-5">
          {{ record.price_view }}
        </div>
        <v-divider></v-divider>
        <v-tabs
          color="blue"
          v-model="tab"
        >
          <v-tab
            class="blue--text ant-font-viga text-transform-none"
            key="page-detail"
          >Detail</v-tab>
          <v-tab
            class="blue--text ant-font-viga text-transform-none"
            key="page-spesifikasi"
          >Spesifikasi</v-tab>
          <v-tab
            class="blue--text ant-font-viga text-transform-none"
            key="page-info"
          >Info Penting</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            key=page-detail
            class="mt-5"
          >
            <div
              class="text-body-2 py-5"
              v-html="record.description"
            >

            </div>
          </v-tab-item>
          <v-tab-item
            key=page-spesifikasi
            class="mt-5"
          >
            <div
              class="text-body-1 py-5"
              v-html="record.spec"
            >

            </div>

          </v-tab-item>
          <v-tab-item
            key=page-info
            class="mt-5"
          >
            <div
              class="text-body-1 py-5"
              v-html="record.info"
            >

            </div>
          </v-tab-item>
        </v-tabs-items>

        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="2">
            <img
              :src="record.logo"
              alt=""
              srcset=""
              width="100%"
              @click="$router.push({name:'umkm'})"
            >
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col col="10">
                <div class="ant-font-viga-xs">
                  {{ record.company_name }}
                </div>

              </v-col>
              <v-col cols="2">
                <v-btn
                  small
                  class="text-transform-none blue flat white--text"
                >Ikuti</v-btn>
              </v-col>
            </v-row>
            <div>
              <v-icon class="mr-2 text-body-2">mdi-star</v-icon>
              <span class="text-sm-body-2">Rata Rata 4 </span>
            </div>
          </v-col>
        </v-row>

      </v-col>
      <v-col cols="3">
        <v-card
          class=""
          outlined
        >
          <v-card-text>
            <div class="ant-font-viga blue--text">AKSI </div>
            <v-col>
              <v-btn
                block
                outlined
                class="blue white--text text-transform-none"
                @click="postBeliLangsung"
              >Beli Langsung</v-btn>
            </v-col>
            <v-col>
              <v-btn
                block
                outlined
                class="blue white--text text-transform-none"
              >Masukan Ke Favorit</v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Mobile View -->

    <v-row
      class="mb-10"
      v-if="device.mobile"
    >
      <v-col cols="12">
        <img
          :src="thumbnail"
          alt=""
          srcset=""
          width="100%"
          height="350px"
        >
        <v-row>
          <v-col
            cols="3"
            v-for="(item,index) in record.images"
            :key="index"
          >
            <img
              :src="item.path"
              alt=""
              srcset=""
              width="100%"
              @mouseenter="setThumbnail(item.path)"
            >
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="1w">
        <div class="ant-font-viga ant-title">
          {{ record.name }}
        </div>
        <div class="ant-font-viga-xs mt-2">
          Dilihat : 100+ <v-icon color="orange darken-1">mdi-medal</v-icon> 200+
        </div>
        <div class="ant-lg-title font-weight-bold mt-5 mb-5">
          {{ record.price_view }}
        </div>
        <v-divider></v-divider>
        <v-tabs
          color="blue"
          v-model="tab"
        >
          <v-tab
            class="blue--text ant-font-viga text-transform-none"
            key="page-detail"
          >Detail</v-tab>
          <v-tab
            class="blue--text ant-font-viga text-transform-none"
            key="page-spesifikasi"
          >Spesifikasi</v-tab>
          <v-tab
            class="blue--text ant-font-viga text-transform-none"
            key="page-info"
          >Info Penting</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            key=page-detail
            class="mt-5"
          >
            <div
              class="text-body-2"
              v-html="record.description"
            >

            </div>
          </v-tab-item>
          <v-tab-item
            key=page-spesifikasi
            class="mt-5"
          >
            <div
              class="text-body-1"
              v-html="record.spec"
            >

            </div>

          </v-tab-item>
          <v-tab-item
            key=page-info
            class="mt-5"
          >
            <div
              class="text-body-1"
              v-html="record.info"
            >

            </div>
          </v-tab-item>
        </v-tabs-items>

        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="2">
            <img
              :src="record.logo"
              alt=""
              srcset=""
              width="100%"
              @click="$router.push({name:'umkm'})"
            >
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col col="10">
                <div class="ant-font-viga-xs">
                  {{ record.company_name }}
                </div>

              </v-col>
              <v-col cols="2">
                <v-btn
                  small
                  class="text-transform-none blue flat white--text"
                >Ikuti</v-btn>
              </v-col>
            </v-row>
            <div>
              <v-icon class="mr-2 text-body-2">mdi-star</v-icon>
              <span class="text-sm-body-2">Rata Rata 4 </span>
            </div>
          </v-col>
        </v-row>

      </v-col>
      <v-col cols="12">
        <v-card
          class=""
          outlined
        >
          <v-card-text>
            <div class="ant-font-viga blue--text">AKSI </div>
            <v-col>
              <v-btn
                block
                outlined
                class="blue white--text text-transform-none"
                @click="postBeliLangsung"
              >Beli Langsung</v-btn>
            </v-col>
            <v-col>
              <v-btn
                block
                outlined
                class="blue white--text text-transform-none"
              >Masukan Ke Favorit</v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
    
    <script>
import { mapState, mapActions } from "vuex";
import "animate.css";
export default {
  name: "product-detail",
  data: () => ({
    tab: null,
    thumbnail: "images/produk5.png",
    record: {},
  }),
  mounted() {
    this.setPage({
      crud: false,
    });
    this.fetchRecord();
  },
  computed: {
    ...mapState(["device", "theme", "info", "http", "snackbar", "auth"]),
  },
  methods: {
    ...mapActions(["setPage", "signIn"]),
    fetchRecord: async function () {
      try {
        let { data } = await this.http.get(
          "product-detail/" + this.$route.params.id
        );
        this.record = data;
        this.setThumbnail(data.images[0].path);
      } catch (error) {}
    },
    setThumbnail: function (val) {
      this.thumbnail = val;
    },
    postBeliLangsung: function () {
      const url = "https://plazabanten.com";
      window.open(url, "__blank");
    },
  },
};
</script>
